import cx from 'classnames';
import {useMemo} from 'react';
import {
  addAffiliateTagsToWishlist,
  getBrandNameAndIcon,
  normalizeUrl,
} from '~/SignUpSheets/utils/misc';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import {EditRemoveButton} from '~library/molecules/EditRemoveButton';
import {ChevronIcon} from '~library/svg/ChevronIcon';

import {coin} from '~libSass/base/_exports.sass';
import './ViewWishlists.sass';

export const ViewWishlists = ({
  wishlists,
  wishlistName,
  onEditClick,
  onRemoveClick,
  blueprintId,
}) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const memoizedWishlists = useMemo(
    () =>
      wishlists.map((wishlist) => {
        const {brandName, iconUrl} = getBrandNameAndIcon(wishlist);

        return (
          <div className="view-wishlist__vendors-item" key={wishlist}>
            <EditRemoveButton
              onEditClick={onEditClick}
              onRemoveClick={() => onRemoveClick(wishlist)}
              dataQaIdSuffix="gift-registry"
              className="add-remove-button__container"
            />
            <Link
              href={addAffiliateTagsToWishlist(normalizeUrl(wishlist), blueprintId)}
              target="_blank"
              className="view-wishlist__vendors-item__link"
              data-qa-id="wishlist-item"
            >
              <img
                src={iconUrl}
                alt={wishlistName}
                className={cx('view-wishlist__vendors-item__image', {
                  'view-wishlist__vendors-item__image-default': !brandName,
                  [`view-wishlist__vendors-item__image--${brandName}`]: brandName,
                })}
              />
              <Typography
                variant="link"
                size="large"
                className="view-wishlist__vendors-item__title"
              >
                View {brandName ? `the ${brandName}` : 'this'} Wishlist
                <ChevronIcon color={coin} ratio={0.5} />
              </Typography>
            </Link>
          </div>
        );
      }),
    [wishlists, blueprintId]
  );

  return <div className="view-wishlist__vendors-list">{memoizedWishlists}</div>;
};
